module.exports = __webpack_public_path__ + "img/404.0e778eef.svg";